import { NgModule } from '@angular/core';
import {
	DisabledInteractiveWrapperComponent
} from './disabled-interactive-wrapper/disabled-interactive-wrapper.component';
import { DisabledInteractiveDirective } from './disabled-interactive.directive';

@NgModule({
	imports: [
		DisabledInteractiveDirective
	],
	declarations: [
		DisabledInteractiveWrapperComponent
	],
	exports: [
		DisabledInteractiveDirective,
		DisabledInteractiveWrapperComponent
	]
})
export class DisabledInteractiveDirectiveModule {}
